/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTableExport = createReactComponent("table-export", "IconTableExport", [
  [
    "path",
    {
      d: "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5",
      key: "svg-0"
    }
  ],
  ["path", { d: "M3 10h18", key: "svg-1" }],
  ["path", { d: "M10 3v18", key: "svg-2" }],
  ["path", { d: "M16 19h6", key: "svg-3" }],
  ["path", { d: "M19 16l3 3l-3 3", key: "svg-4" }]
]);

export { IconTableExport as default };
//# sourceMappingURL=IconTableExport.js.map
